//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uniRate from "@/components/uni-rate/uni-rate.vue"
import uniLoadMore from "@/components/uni-load-more/uni-load-more.vue"
import {getListByCode} from "@/common/js/dictionary.js"
import search from "@/components/search/index.vue"
import calendarPage from '@/components/calendarPage/calendarpage.vue'
import moment from 'dayjs'
export default {
    data() {
        return {
            //顶部
            header:'',
            noImg:require('static/noimage.png'),
            headerJumpUrl:'',
            actions:[],
            labelList:[],
            hotelBodyTypeCode:'',
            sortList: [
                { name: '价格高到低', code: 2 },
                { name: '价格低到高', code: 1 },
                { name: '离我最近', code: 3 }
            ],
            sortType:'0',
            list:[],
            name:'',
            cityKey:0,
            city:{
                provinceCode:'',
                cityCode:'',
                districtCode:'',
                name:'地区'
            },
            cityName:'地区',
            IsCalender:false,
            close:false,
            info:{
                checkInDate: '',
                checkOutDate: '',
                startDate: ''
            },
            isFixed:false,
            //列表
            end:false,
            count:0,
            page: {
                pageSize: 10,
                currentPage: 1,
                count: 0,
                loading: false
            },
            menu: [ // 筛选菜单栏
                {
                    title: '酒店类型',
                    detailList: []
                },
                {
                    title: '排序',
                    detailList: [
                        { name: '价格高到低', code: 2 },
                        { name: '价格低到高', code: 1 },
                        { name: '离我最近', code: 3 },
                        { name: '评分高到低', code: 4 }
                    ]
                }
            ]
        }
    },
    components:{uniRate,uniLoadMore,search,calendarPage},
    computed: {
        total () {
            var date1 = new Date(this.info.checkInDate.replace(/-/gm, '/'))
            var date2 = new Date(this.info.checkOutDate.replace(/-/gm, '/'))
            return parseInt((date2 - date1) / (24 * 60 * 60 * 1000))
        }
    },
    onReady(){



    },
    onLoad() {
        this.info.startDate = moment().format('YYYY-M-D')
        this.info.checkInDate = moment().format('YYYY-M-D')
        this.info.checkOutDate = moment().add(1, 'day').format('YYYY-M-D')
        this.getList()
        // this.getLocation()
        this.queryHoteTypes()
    },
    onPullDownRefresh() {
        this.list=[]
        this.page.currentPage=1
        this.getList('refresh')
    },
    onReachBottom() {
        if(this.list.length<this.count){
        this.getList()
        }
    },
    methods:{
        //列表页
        getList(status){
            let _this=this
            _this.page.loading=true
            let inDate = _this.dateFormat(this.info.checkInDate)
            let outDate = _this.dateFormat(this.info.checkOutDate)
            this.$ajax({
                method: 'post',
                url: '/weChat/hotelbody/queryPage',
                data: {
                    ...this.city,
                    bodyName: this.name,
                    // districtCode: this.city.code,
                    status: 1,
                    currentPage:this.page.currentPage,
                    pageSize: this.page.pageSize,
                    beginDate: inDate,
                    endDate: outDate,
                    hotelBodyTypeCode:_this.hotelBodyTypeCode,
                    sortType:_this.sortType,
                    orderByIndex: 10
                }
            }).then(res=>{
                _this.list.push.apply(_this.list,res.data)
                _this.page.loading=false
                _this.count=res.count
                if(_this.list.length>=_this.count){
                    _this.end=true
                }
                _this.page.currentPage+=1
                if(status==='refresh'){
                    uni.stopPullDownRefresh();
                }
            })
        },
        // 日期补0
        dateFormat (date) {
            let dateArray = date.split('-')
            let month =
                parseInt(dateArray[1]) < 10 ? '0' + dateArray[1] : dateArray[1]
            let day = parseInt(dateArray[2]) < 10 ? '0' + dateArray[2] : dateArray[2]
            return dateArray[0] + '-' + month + '-' + day
        },
        // 弹出日历
        huangxing () {
            this.IsCalender = true
        },
        handeldetermine (date) {
            this.info = date
            this.close = true
            this.search()
            this.IsCalender = false
        },
        // 日历关闭
        handelClose () {
            this.close = true
            setTimeout(()=>{							
				this.IsCalender = false
            },300)
        },
        //顶部搜索
        nameInput(e){
            this.name=e.target.value
        },
        // 地区搜索		
        changePicker(e){
            console.log(e)
            this.city={
                provinceCode:e.cityCode.province?e.cityCode.province+'0000000000':'',
                cityCode:e.cityCode.city?e.cityCode.city+'00000000':'',
                districtCode:e.cityCode.area?e.cityCode.area+'000000':'',
                name:e.label
            }
            this.search()
        },
        confirm(item) {
            if (item.index === 0) {
                this.hotelBodyTypeCode=item.code || ''
            } else if (item.index === 1) {
                this.sortType = item.code || ''
            }
            this.search()
        },
        reset(index){
            console.log(index)
            if(index===0){
               this.hotelBodyTypeCode='' 
            }else if(index === 1) {
                this.sortType = '0'
            }
            this.search()
        },
        search(){
            this.list=[]
            this.page.currentPage=1
            this.getList()
        },
        scroll(e){
            let _top=e.detail.scrollTop
            if(_top>13){
                this.isFixed=true
            }else{
                this.isFixed=false
            }
        },
        //顶部省市区
        getLocation(){
            let code = '330700000000'
            let data = getListByCode(code)
            let _this=this
            data.then(result=>{
                console.log(result)
                _this.actions = result.map(t => {
                    return {
                    name: t.name,
                    code: t.code
                    }
                })
                _this.actions.unshift({
                    name: '金华市',
                    code: ''
                })
                _this.city=_this.actions[0]
            })
        },
        queryHoteTypes () {
            this.$ajax({
                method: 'post',
                url: '/weChat/hotelbody/queryHoteTypes',
                data: {}
            }).then(res=>{
                // this.labelList = res.data
                this.menu[0].detailList=res.data
            })
        },
    }
}
